import React from 'react';
import HeroSection from '../../components/ui/HeroSection';
import ContactSection from './ContactSection';

function Contact() {
  return (
    <>
      <HeroSection navList={['home', 'contact']} title="contact me" />
      <ContactSection />
    </>
  );
}

export default Contact;
